import { render, staticRenderFns } from "./customer-receipt.vue?vue&type=template&id=c55924a0&"
import script from "./customer-receipt.vue?vue&type=script&lang=js&"
export * from "./customer-receipt.vue?vue&type=script&lang=js&"
import style0 from "./customer-receipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports